export function PostCaption({ caption }: { caption: string }) {
  return caption.split(/(#\w+)/).map((part, index) =>
    part.startsWith("#") ? (
      <span className="text-utility-blue-700" key={index}>
        {part}
      </span>
    ) : (
      part
    ),
  );
}
